import { createSlice } from "@reduxjs/toolkit";
import { ProfileHeaderProps } from "web/react/components/profile-header/profile-header";

export interface FollowDesignerBannerSlice {
    show: boolean;
    profile: ProfileHeaderProps;
}

const followDesignerBanner = createSlice({
    name: "followDesignerBanner",
    initialState: {
        show: false,
        profile: {},
    } as FollowDesignerBannerSlice,
    reducers: {
        triggerBanner(state, action): void {
            state.show = action.payload;
        },
        setDesignerProfile(state, action): void {
            state.profile = action.payload;
        },
    },
});

export const { triggerBanner, setDesignerProfile } = followDesignerBanner.actions;
export default followDesignerBanner.reducer;
